export interface PeriodFilterType {
  period: server.dto.PeriodFilterOptions
  target: server.dto.PeriodFilterTargets
  selectionEnd: moment.Moment
  selectionStart: moment.Moment
}

export const initialPeriodFilter: PeriodFilterType = {
  period: "unknown",
  target: undefined,
  selectionEnd: undefined,
  selectionStart: undefined,

};
